import { mapState, mapGetters, mapActions } from 'vuex';

import PzButton from '@/components/PzButton.vue';

import { QaQuestionUpdateMixin } from '@/scripts/QA/Question/mixins/QaQuestionUpdateMixin';

import { swalWarning } from '@/utils/swal2';

export default {
  name: 'Thumb',

  mixins: [QaQuestionUpdateMixin],

  components: {
    PzButton,
  },

  props: {
    p_objQa: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState('QA/Question', {
      ms_res_thumb: 'res_thumb',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_hasLogin() {
      return !this.mg_userInfo.unLogin;
    },

    c_isThumbDisabled() {
      return this.c_hasLogin && this.p_objQa.isThumb != 0;
    },
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_doThumb: 'doThumb',
    }),

    async doThumb(thumbType) {
      if (!this.mg_userInfo.isCurrentStudent) {
        swalWarning('你是未付费用户不能赞/踩');
      } else {
        await this.ma_doThumb({
          answerId: this.p_objQa.qaAnswerId,
          thumbType,
        });
        if (200 === this.ms_res_thumb.status) {
          const { numOfLikes, numOfDislikes } = this.p_objQa;
          this.updateObjQa(this.p_objQa, {
            numOfLikes: 1 === thumbType ? numOfLikes + 1 : numOfLikes,
            numOfDislikes: 1 === thumbType ? numOfDislikes : numOfDislikes + 1,
            isThumb: 1,
          });
        }
      }
    },

    thumbUp() {
      this.doThumb(1);
    },

    thumbDown() {
      this.doThumb(0);
    },
  },
};
